import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import AppointmentService from '../utils/AppointmentService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var parser = require('parse-address');

// if (!window.Promise) {
//   window.Promise = Promise;
// }
class VehicleForm extends Component {

  constructor(props) {
    super(props);

    this.Auth = new AuthService()
    this.Appt = new AppointmentService()

    this.state = {
      year: props.year,
      make: props.make,
      model: props.model,
      color: props.color,
      id: props.id,
      make_id: '',
      model_id: '',
      vtype: 1,
      years: [],
      yearOptions: [],
      makeOptions: [],
      error: null,
      isEditing: props.isEditing
    };
    if(props.year){
      this.Appt.get_vehicle_makes(props.year)
             .then(res =>{
               if(res){
                 const makeOptions = res.vehicles.map(x =>
                   ({target: 'make', value: x.id, label: x.name})
                 );
                 var makeId
                 makeOptions.forEach(function(option){
                   if(option.label.toLowerCase()  == props.make.toLowerCase()){
                     makeId = option.value;
                   }
                 })
                 this.setState({
                   makeOptions: makeOptions,
                   make_id: makeId,
                 })
                 if(makeId){
                   this.Appt.get_vehicle_models(makeId, props.year)
                          .then(res =>{
                            if(res.vehicles){
                              const modelOptions = res.vehicles.map(x =>
                                ({target: 'model', value: x.id, label: x.name.toString()})
                              );
                              var modelId
                              modelOptions.forEach(function(option){
                                if(option.label == props.model){
                                  modelId = option.value;
                                }
                              })
                              this.setState({
                                modelOptions: modelOptions,
                                model_id: modelId
                              })
                            //  this.props.history.replace('/');
                           }
                           else {
                             this.setState({
                               modelOptions: []
                             })
                           }
                          })
                          .catch(err =>{
                              alert(err);
                          })
                        }
               }
             //  this.props.history.replace('/');
             })
             .catch(err =>{
                 const makeOptions = []
             })
    }
      this.Appt.get_vehicle_years()
           .then(res =>{
             const yearOptions = res.vehicles.map(x =>
               ({target: 'year', value: x.toString(), label: x.toString()})
             );
             this.setState({
               yearOptions: yearOptions
             })
           //  this.props.history.replace('/');
           })
           .catch(err =>{
               alert(err);
           })
  }

  componentWillReceiveProps(nextProps){
  }

  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }
  handleYearChange = event => {
    if(event){
      this.setState({
        year: event.value
      });
      this.Appt.get_vehicle_makes(event.value)
             .then(res =>{
               if(res){
                 const makeOptions = res.vehicles.map(x =>
                   ({target: 'make', value: x.id, label: x.name})
                 );
                 this.setState({
                   makeOptions: makeOptions
                 })
               }
             //  this.props.history.replace('/');
             })
             .catch(err =>{
                 const makeOptions = []
             })
    }
    else {
      this.setState({
        year: ''
      })
    }
  }

  handleMakeChange = event => {
    if(event){
      this.setState({
        make_id: event.value,
        make: event.label
      });
      this.Appt.get_vehicle_models(event.value, this.state.year)
             .then(res =>{
               if(res.vehicles){
                 const modelOptions = res.vehicles.map(x =>
                   ({target: 'model', value: x.id, label: x.name.toString()})
                 );
                 this.setState({
                   modelOptions: modelOptions
                 })
               //  this.props.history.replace('/');
              }
              else {
                this.setState({
                  modelOptions: []
                })
              }
             })
             .catch(err =>{
                 alert(err);
             })
    }
    else {
      this.setState({
        make_id: '',
        make: ''
      });
    }
  }
  handleModelChange = event => {
    if(event){
      this.setState({
        model_id: event.value,
        model: event.label
      });
      this.Appt.get_vehicle_type(this.state.year, this.state.make_id, event.value)
             .then(res =>{
               this.setState({
                 vtype: res
               })
             })
             .catch(err =>{
                 alert(err);
             })
    }
    else {
      this.setState({
        model_id: '',
        model: ''
      });
    }
  }
  handleColorChange = event => {
      this.setState({
        color: event.target.value
      });
  }
  clearValue = e => {
    this.select.setInputValue('');
  }
  handleSubmit = event =>  {
    event.preventDefault()
    if(!this.state.year){
      this.setState({
        error: "Year is blank or Invalid"
      })
    }
    else if(!this.state.make){
      this.setState({
        error: "Make is blank or Invalid"
      })
    }
    else if(!this.state.model){
      this.setState({
        error: "Model is blank or Invalid"
      })
    }
    else if(!this.state.color){
      this.setState({
        error: "Color is blank or Invalid"
      })
    }
    else if(this.state.isEditing){
      this.Appt.updateVehicle(this.state.year,this.state.make, this.state.model, this.state.color, this.state.vtype, this.state.id)
            .then(res =>{
              if(res){
                  this.props.closeModal()
                  this.props.selectVehicle(res.vehicle)
              }
              else {
                error: "Error Saving Vehicle"
              }
              //  this.props.history.replace('/');
            })
            .catch(err =>{
                  error: "Error Saving Vehicle"
            })
    }
    else{
      this.Appt.saveVehicle(this.state.year,this.state.make, this.state.model, this.state.color, this.state.vtype)
            .then(res =>{
              if(res){
                  this.props.closeModal()
                  this.props.selectVehicle(res.vehicle)
              }
              else {
                error: "Error Saving Vehicle"
              }
              //  this.props.history.replace('/');
            })
            .catch(err =>{
                  error: "Error Saving Vehicle"
            })
        }
  }


    render(){
      return (
              <div className='vehicleForm'>
                <form onSubmit={this.handleSubmit}>
                  <p className="whiteText">{this.state.error}</p>
                  <div className="form-group ">
                  <Select
                    name="form-field-name"
                    value={this.state.year}
                    placeholder="Year"
                    clearable={true}
                    onChange={this.handleYearChange}
                    options={this.state.yearOptions}
                    id="year"
                  />
                  </div>
                  <div className="form-group ">
                  <Select
                    name="form-field-name"
                    value={this.state.make_id}
                    placeholder="Make"
                    onChange={this.handleMakeChange}
                    options={this.state.makeOptions}
                    id="make"
                  />
                  </div>
                  <div className="form-group ">
                  <Select
                    name="form-field-name"
                    placeholder="Model"
                    value={this.state.model_id}
                    onChange={this.handleModelChange}
                    options={this.state.modelOptions}
                    id="make"
                  />
                  </div>
                  <div className="form-group ">
                    <input className="form-control" type="text" id="color" value={this.state.color} onChange={this.handleColorChange} placeholder="Color" ></input>
                  </div>
                  <div className="form-group">
                  <div className = "bottomButtons3">
                    <button className="btn successButtonFlex btn-block text-center" type="submit">Save Vehicle</button>
                    <button onClick = {() => this.props.closeModal()}className="btn btn-block cancelButtonFlex text-center">Cancel</button>
                  </div>
                  </div>
                </form>
              </div>
              )
    }
}
export default VehicleForm;



// WEBPACK FOOTER //
// ./src/Components/VehicleForm.js